import { filtersType } from '../hooks/remediations/useRemediations';
import { Paginated } from '../types';
import { Remediation } from '../types/remediations.type';
import { ApiRepository } from './main repository/api.repository';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace RemediationService {
  const BASE_API = `${window.globalConfiguration.api.base}/v1/remediations`;

  export const getAll = async ({
    page,
    limit,
    recordFrom,
    filters,
    recordTo,
  }: {
    page: number;
    limit: number;
    recordFrom: string | null | undefined;
    recordTo: string | null | undefined;
    filters: Record<string, filtersType>;
  }): Promise<Paginated<Remediation>> => {
    return ApiRepository.Core().get<Paginated<Remediation>>(BASE_API, {
      page,
      limit,
      recordFrom,
      recordTo,
      ...filters,
    });
  };

  export const getExport = async ({
    recordFrom,
    filters,
    recordTo,
  }: {
    query?: string;
    recordFrom: string | null | undefined;
    recordTo: string | null | undefined;
    filters: Record<string, filtersType>;
  }): Promise<Buffer> => {
    return ApiRepository.Core().get(
      `${BASE_API}/export`,
      { recordFrom, recordTo, ...filters },
      {
        responseType: 'blob',
      }
    );
  };
}
